export enum ToolbarDesign {
  Auto = 'Auto',
  Info = 'Info',
  Solid = 'Solid',
  Transparent = 'Transparent'
}
